module.exports = __webpack_public_path__ + "img/portrait-032.122651a4.jpg";